import { z } from "zod"

/**
 * Define o schema para as variáveis de ambiente.
 * Isso garante que as variáveis carregadas do .env sejam do tipo correto.
 */
const envSchema = z.object({
  VITE_API_URL: z.url({ message: "A API_URL deve ser uma URL válida." }),
  VITE_APP_TITLE: z.string().default("Painel Administrativo"),
  VITE_ENV: z.enum(["development", "production", "test"]).default("development"),
})

// Valida as variáveis de ambiente em tempo de execução
const parsedEnv = envSchema.safeParse(import.meta.env)

if (!parsedEnv.success) {
  console.error("❌ Variáveis de ambiente inválidas:", parsedEnv.error.flatten().fieldErrors)
  throw new Error("Variáveis de ambiente inválidas.")
}

// Exporta um objeto de configuração imutável e tipado
export const config = Object.freeze({
  apiUrl: parsedEnv.data.VITE_API_URL,
  env: parsedEnv.data.VITE_ENV,
  appTitle: parsedEnv.data.VITE_APP_TITLE,
  isDevelopment: parsedEnv.data.VITE_ENV === "development",
  isProduction: parsedEnv.data.VITE_ENV === "production",
})
